/**
 * Gets the target image index, wrapping around the list boundaries.
 */
export const getWrappedImageNavigationIndex = ({
    currentIndex,
    imageCount,
    direction,
}: {
    currentIndex: number;
    imageCount: number;
    direction: -1 | 1;
}): number | undefined => {
    if (currentIndex < 0 || imageCount < 2) return undefined;

    return (currentIndex + direction + imageCount) % imageCount;
};
